import Layout from "@/components/feature/Layout";
import Hero from "./components/Hero";
import CategoryIndex from "./components/CategoryIndex";
import FeaturedCollections from "./components/FeaturedCollections";
import LatestArchive from "./components/LatestArchive";
import Testimonials from "./components/Testimonials";
import HomeFaq from "./components/HomeFaq";
import CtaBanner from "./components/CtaBanner";

export default function Home() {
  return (
    <Layout>
      <Hero />
      <CategoryIndex />
      <FeaturedCollections />
      <LatestArchive />
      <Testimonials />
      <HomeFaq />
      <CtaBanner />
    </Layout>
  );
}